import hero from "./assets/osh_hero.jpg"
import thumbnailHero from "./assets/osh_hero.jpg"


export const HardwarePrototypingData = {
    title: "Bringing Ideas to Life and Sharing my Passion for Making",
    heroImage: hero,
    thumbnailImage:hero
}